module.exports = __webpack_public_path__ + "static/img/084.5bf4553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/084.png
// module id = 3LPJ
// module chunks = 0